module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#technology",
      toString: function () {
        return this.url;
      }
    }